import { useQuery, useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';
import { SubscriptionResponse } from '../types';

type UseSubscriptionsOptions = {
  search?: string;
  page: number;
  perPage: number;
  isPast?: boolean;
};
export const getSubscriptions = (
  { search, page, perPage, isPast }: UseSubscriptionsOptions = {
    page: 1,
    perPage: 10,
  }
): Promise<SubscriptionResponse> => {
  return axios.get(`/plans/get-subscribers-list`, {
    params: { search, page, perPage },
  });
};

type UseUpdateSubscriptionOptions = {
  config?: MutationConfig<typeof getSubscriptions>;
};

export const useGetSubscriptions = ({ config }: UseUpdateSubscriptionOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getSubscriptions,
  });
};
